module.exports = __webpack_public_path__ + "static/media/nissan-headset.e9f3d3a7.svg";